/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  DASHBOARD_CLEAN_REQUEST,
  DASHBOARD_TASK_COUNT_FETCH_REQUEST,
  DASHBOARD_TASK_COUNT_FETCH_REQUEST_SUCCESS,
  DASHBOARD_TASK_COUNT_FETCH_REQUEST_FAILURE,
  DASHBOARD_APPOINTMENT_COUNT_FETCH_REQUEST,
  DASHBOARD_APPOINTMENT_COUNT_FETCH_REQUEST_SUCCESS,
  DASHBOARD_APPOINTMENT_COUNT_FETCH_REQUEST_FAILURE,
  DASHBOARD_INVOICE_AMOUNT_FETCH_REQUEST,
  DASHBOARD_INVOICE_AMOUNT_FETCH_REQUEST_SUCCESS,
  DASHBOARD_INVOICE_AMOUNT_FETCH_REQUEST_FAILURE,
  DASHBOARD_TASK_COUNT_ASSIGNED_BY_FETCH_REQUEST,
  DASHBOARD_TASK_COUNT_ASSIGNED_BY_FETCH_REQUEST_SUCCESS,
  DASHBOARD_TASK_COUNT_ASSIGNED_BY_FETCH_REQUEST_FAILURE,
  DASHBOARD_INVOICE_SUMMARY_FETCH_REQUEST,
  DASHBOARD_INVOICE_SUMMARY_FETCH_REQUEST_SUCCESS,
  DASHBOARD_INVOICE_SUMMARY_FETCH_REQUEST_FAILURE,
  DASHBOARD_GOAL_FETCH_REQUEST,
  DASHBOARD_GOAL_FETCH_REQUEST_SUCCESS,
  DASHBOARD_GOAL_FETCH_REQUEST_FAILURE,
  DASHBOARD_UNREAD_MESSAGE_FETCH_REQUEST,
  DASHBOARD_UNREAD_MESSAGE_FETCH_REQUEST_SUCCESS,
  DASHBOARD_UNREAD_MESSAGE_FETCH_REQUEST_FAILURE,
  DASHBOARD_TASKBAR_FETCH_REQUEST,
  DASHBOARD_TASKBAR_FETCH_REQUEST_SUCCESS,
  DASHBOARD_TASKBAR_FETCH_REQUEST_FAILURE,
  DASHBOARD_TASK_SUMMARY_FETCH_REQUEST,
  DASHBOARD_TASK_SUMMARY_FETCH_REQUEST_SUCCESS,
  DASHBOARD_TASK_SUMMARY_FETCH_REQUEST_FAILURE,
  LANGUAGE_DROPDOWN_FETCH_REQUEST,
  LANGUAGE_DROPDOWN_FETCH_REQUEST_SUCCESS,
  LANGUAGE_DROPDOWN_FETCH_REQUEST_FAILURE,
  DASHBOARD_UNREAD_DOCUMENT_FETCH_REQUEST,
  DASHBOARD_UNREAD_DOCUMENT_FETCH_REQUEST_SUCCESS,
  DASHBOARD_UNREAD_DOCUMENT_FETCH_REQUEST_FAILURE,
} from './types';

const INITIAL_STATE = {
  taskCount: [],
  taskCountLoading: false,
  taskCountErrors: {},
  taskCountAssignedBy: [],
  taskCountAssignedByLoading: false,
  taskCountAssignedByErrors: {},
  appointmentCount: [],
  appointmentCountLoading: false,
  appointmentCountErrors: {},
  invoiceAmount: [],
  invoiceAmountLoading: false,
  invoiceAmountErrors: {},
  invoiceSummary: [],
  invoiceSummaryLoading: false,
  invoiceSummaryErrors: {},
  goal: [],
  goalLoading: false,
  goalErrors: {},
  taskBar: [],
  taskBarLoading: false,
  taskBarErrors: {},
  taskSummary: [],
  taskSummaryLoading: false,
  taskSummaryErrors: {},
  unreadMessage: [],
  unreadMessageLoading: false,
  unreadMessageErrors: {},
  languageDropdown: [],
  languageDropdownLoading: false,
  languageDropdownErrors: {},
  unreadDocument: [],
  unreadDocumentLoading: false,
  unreadDocumentErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const dashboardReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case DASHBOARD_TASK_COUNT_FETCH_REQUEST:
      return Object.assign({}, state, {
        taskCountLoading: true,
      });

    case DASHBOARD_TASK_COUNT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taskCount: action.data,
        taskCountLoading: false,
        taskCountErrors: {},
      });

    case DASHBOARD_TASK_COUNT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taskCountLoading: false,
        taskCountErrors: action.error,
      });

    case DASHBOARD_TASK_COUNT_ASSIGNED_BY_FETCH_REQUEST:
      return Object.assign({}, state, {
        taskCountAssignedByLoading: true,
      });

    case DASHBOARD_TASK_COUNT_ASSIGNED_BY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taskCountAssignedBy: action.data,
        taskCountAssignedByLoading: false,
        taskCountAssignedByErrors: {},
      });

    case DASHBOARD_TASK_COUNT_ASSIGNED_BY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taskCountAssignedByLoading: false,
        taskCountAssignedByErrors: action.error,
      });

    case DASHBOARD_APPOINTMENT_COUNT_FETCH_REQUEST:
      return Object.assign({}, state, {
        appointmentCountLoading: true,
      });

    case DASHBOARD_APPOINTMENT_COUNT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        appointmentCount: action.data,
        appointmentCountLoading: false,
        appointmentCountErrors: {},
      });

    case DASHBOARD_APPOINTMENT_COUNT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        appointmentCountLoading: false,
        appointmentCountErrors: action.error,
      });

    case DASHBOARD_INVOICE_AMOUNT_FETCH_REQUEST:
      return Object.assign({}, state, {
        invoiceAmountLoading: true,
      });

    case DASHBOARD_INVOICE_AMOUNT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        invoiceAmount: action.data,
        invoiceAmountLoading: false,
        invoiceAmountErrors: {},
      });

    case DASHBOARD_INVOICE_AMOUNT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        invoiceAmountLoading: false,
        invoiceAmountErrors: action.error,
      });

    case DASHBOARD_INVOICE_SUMMARY_FETCH_REQUEST:
      return Object.assign({}, state, {
        invoiceSummaryLoading: true,
      });

    case DASHBOARD_INVOICE_SUMMARY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        invoiceSummary: action.data,
        invoiceSummaryLoading: false,
        invoiceSummaryErrors: {},
      });

    case DASHBOARD_INVOICE_SUMMARY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        invoiceSummaryLoading: false,
        invoiceSummaryErrors: action.error,
      });

    case DASHBOARD_GOAL_FETCH_REQUEST:
      return Object.assign({}, state, {
        goalLoading: true,
      });

    case DASHBOARD_GOAL_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        goal: action.data,
        goalLoading: false,
        goalErrors: {},
      });

    case DASHBOARD_GOAL_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        goalLoading: false,
        goalErrors: action.error,
      });

    case DASHBOARD_UNREAD_MESSAGE_FETCH_REQUEST:
      return Object.assign({}, state, {
        unreadMessageLoading: true,
      });

    case DASHBOARD_UNREAD_MESSAGE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        unreadMessage: action.data,
        unreadMessageLoading: false,
        unreadMessageErrors: {},
      });

    case DASHBOARD_UNREAD_MESSAGE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        unreadMessageLoading: false,
        unreadMessageErrors: action.error,
      });

    case DASHBOARD_TASKBAR_FETCH_REQUEST:
      return Object.assign({}, state, {
        taskBarLoading: true,
      });

    case DASHBOARD_TASKBAR_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taskBar: action.data,
        taskBarLoading: false,
        taskBarErrors: {},
      });

    case DASHBOARD_TASKBAR_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taskBarLoading: false,
        taskBarErrors: action.error,
      });

    case DASHBOARD_TASK_SUMMARY_FETCH_REQUEST:
      return Object.assign({}, state, {
        taskSummaryLoading: true,
      });

    case DASHBOARD_TASK_SUMMARY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taskSummary: action.data,
        taskSummaryLoading: false,
        taskSummaryErrors: {},
      });

    case DASHBOARD_TASK_SUMMARY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taskSummaryLoading: false,
        taskSummaryErrors: action.error,
      });

    case DASHBOARD_CLEAN_REQUEST:
      return Object.assign({}, state, {
        taskCount: [],
        taskCountLoading: false,
        taskCountErrors: {},
        taskCountAssignedBy: [],
        taskCountAssignedByLoading: false,
        taskCountAssignedByErrors: {},
        appointmentCount: [],
        appointmentCountLoading: false,
        appointmentCountErrors: {},
        invoiceAmount: [],
        invoiceAmountLoading: false,
        invoiceAmountErrors: {},
        taskBar: [],
        taskBarLoading: false,
        taskBarErrors: {},
        taskSummary: [],
        taskSummaryLoading: false,
        taskSummaryErrors: {},
        unreadMessage: [],
        unreadMessageLoading: false,
        unreadMessageErrors: {},
      });

    case LANGUAGE_DROPDOWN_FETCH_REQUEST:
      return Object.assign({}, state, {
        languageDropdownLoading: true,
      });

    case LANGUAGE_DROPDOWN_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        languageDropdown: action.data,
        languageDropdownLoading: false,
        languageDropdownErrors: {},
      });

    case LANGUAGE_DROPDOWN_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        languageDropdownLoading: false,
        languageDropdownErrors: action.error,
      });

    case DASHBOARD_UNREAD_DOCUMENT_FETCH_REQUEST:
      return Object.assign({}, state, {
        unreadDocumentLoading: true,
      });

    case DASHBOARD_UNREAD_DOCUMENT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        unreadDocument: action.data,
        unreadDocumentLoading: false,
        unreadDocumentErrors: {},
      });

    case DASHBOARD_UNREAD_DOCUMENT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        unreadDocumentLoading: false,
        unreadDocumentErrors: action.error,
      });

    default:
      return state;
  }
};

export default dashboardReducer;
